import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const calculatorListEndpoint = ApiEndpoints.calculator.calculatorList;
const calculatorDeleteEndpoint = ApiEndpoints.calculator.calculatorDelete;

const newsEditPath = "edit-calculator";
const tableHeader = ["Root Opt", "Root Opt Fleet Efficiency", "Root Opt Driver", "Root Opt Fuel", "Fuel Cost Per Litre", "Annual Days", "Working Hours Per Day", "Software Cost ($)"];
const tbody = ["root_opt", "root_opt_fleet_efficiency", "root_opt_driver", "root_opt_fuel", "fuel_cost_per_litre", "annual_days", "working_hours_per_day", "annual_software_cost"];

export default function CalculatorListing() {
    const [data, setData] = useState([]);
    const dataFetch = async () => {
        try {
            const response = await ApiRequest("GET", calculatorListEndpoint);
            const result = response?.roi_calculator_data || [];
            setData(result);
        } catch (error) {
            console.error("Fetch Error:", error);
        }
    };

    useEffect(() => {
        dataFetch();
    }, []);


    const handleDelete = async (roicalculator_id) => {
        const payload = { roicalculator_id };
        try {
            const response = await ApiRequest("POST", calculatorDeleteEndpoint, payload);
            toast.success(response?.message || "Deleted successfully");
            dataFetch();
        } catch (error) {
            console.error("Delete Error:", error);
        }
    };

    const pagename = {
        name: 'Calculator Management',
        user: 'Admin',
        innerpage: 'Calculator Management / Calculator'
    };

    return (
        <>
            <AdminHeader pagename={pagename} />
            <div className="add-btn-section">
                {data.length === 0 && (
                    <Link className="admin-add-btn" to="/add-calculator">
                        Add +
                    </Link>
                )}
                <DataTable
                    data={data}
                    tableHeader={tableHeader}
                    tbody={tbody}
                    editPath={newsEditPath}
                    onDelete={handleDelete}
                />
            </div>
        </>
    );
}